<template>
  <b-modal
    id="modal-segments"
    title="Todos os Segmentos"
    size="xl"
    ok-title="Salvar"
    cancel-title="Cancelar"
    @hidden="leave"
    @ok="save"
  >
    <div
      v-if="loading"
      class="text-center"
    >
      <b-spinner
        variant="primary"
        type="grow"
        label="Spinning"
      ></b-spinner>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-6">
          <div class="custom-control custom-checkbox my-1 mr-sm-2">
            <input
              @click="selectAll"
              type="checkbox"
              class="custom-control-input"
              id="select-all"
              name="select-all"
            />
            <label
              class="custom-control-label"
              for="select-all"
            >Selecionar Tudo</label>
          </div>
        </div>
        <div class="col-6">
          <b-form-input
            v-model="filter"
            @keyup="filterItems"
            placeholder="Pesquisar Segmento"
            size="sm"
          />
        </div>
      </div>
      <hr />
      <div class="row dealers-area mt-4">
        <div class="col-12">
          <div
            v-for="(segment, i) in mySegments"
            :key="i"
          >
            <div class="custom-control custom-checkbox my-1 mr-sm-2">
              <input
                @click="addSegment($event, segment)"
                type="checkbox"
                class="custom-control-input"
                :value="segment.descricao"
                :id="`${segment.descricao}-${i}`"
                :name="`${segment.descricao}-${i}`"
                :checked="check(segment.segmento)"
              />
              <label
                class="custom-control-label"
                :for="`${segment.descricao}-${i}`"
              >{{ segment.descricao }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
// import { mapActions } from 'vuex';
// import { mapFields } from 'vuex-map-fields';
import axios from 'axios';
import EventBus from '../../../eventBus';

const url = 'https://api.bi-assobens.com.br/v1';
// const url = 'http://localhost:3000/v1';

export default {
  props: ['userSegments', 'userId'],

  data: () => ({
    checked: false,
    filter: null,
    loading: true,
    segments: [],
    mySegments: [],
    ids: [],
    userAuth: null,
  }),

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_pbiAssobens'));
  },

  async mounted() {
    await this.carregaSegmentos();
    this.loading = false;
  },

  computed: {},

  methods: {

    async carregaSegmentos() {
      try {
        const { data } = await axios.get(`${url}/dados/segmentos`);
        this.segments = data;
        this.mySegments = this.segments;
        this.userSegments.forEach((el) => {
          this.ids.push(el.segmentId);
        });
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },

    filterItems() {
      this.mySegments = this.segments.filter(
        // eslint-disable-next-line
        (el) => el.descricao.toLowerCase().indexOf(this.filter.toLowerCase()) > -1,
      );
    },

    selectAll(event) {
      this.ids = [];

      if (event.target.checked) {
        this.segments.forEach((el) => {
          this.ids.push(el.segmento);
        });
      }
    },

    addSegment(event, segment) {
      if (event.target.checked) {
        this.ids.push(segment.segmento);
      } else {
        const arr = [];

        for (let i = 0; i < this.ids.length; i += 1) {
          // eslint-disable-next-line eqeqeq
          if (!(this.ids[i] == segment.segmento)) {
            arr.push(this.ids[i]);
          }
        }
        this.ids = arr;
      }
    },

    check(id) {
      for (let i = 0; i < this.ids.length; i += 1) {
        // eslint-disable-next-line eqeqeq
        if (this.ids[i] == id) return true;
      }
      return false;
    },

    leave() {
      this.checked = false;
      this.filter = null;
      this.ids = [];
      this.mySegments = this.segments;

      this.userSegments.forEach((el) => {
        this.ids.push(el.segmento);
      });
    },

    save() {
      EventBus.$emit('saveUserSegments', this.ids);
      this.checked = false;
      this.filter = null;
      this.ids = [];
      this.mySegments = this.segments;
    },
  },
};
</script>

<style scoped>
.dealers-area {
  min-height: 350px;
  max-height: 350px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
